import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { InputNumber } from 'primereact/inputnumber';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries } from '../../../appconfig/Settings';

import { ApplicationTab } from '../applicationTab';
import { OtherApplicationTab } from './OtherApplicationTab';
import { PENALTY_UPDATE, PENALTY_UPDATE_JAN_VISHWAS, SEARCH_APPLICATION } from '../../../config/ApiConstant';
import { getAllDetails, postAllData } from '../../../service/ProductService';
import { SearchDetailsColumns } from '../../../appconfig/DatatableSetting';
import { applicationsDOBTemplate, collegeNameTemplate, joiningYearTemplate, passingYearTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { set } from 'date-fns';
import { PanaltyUnderJanVishwas } from '../../../config/Validate';

export const SearchByName = () => {
    document.title = 'Search Application | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [penaltySrNo, setPenaltySrNo] = useState<any>(null);
    const [penaltySrNoJanVishwas, setPenaltySrNoJanVishwas] = useState<any>(null);
    const [penaltyStatus, setPenaltyStatus] = useState<any>(null);
    const [penaltyAmountJanVishwas, setPenaltyAmountJanVishwas] = useState<any>(null);
    const [penaltyModal, setPenaltyModal] = useState<boolean>(false);
    const [penaltyJanVishwasModal, setPenaltyJanVishwasModal] = useState<boolean>(false);
    const [penaltyLoader, setPenaltyLoader] = useState<boolean>(false);
    const [penaltyJanVishwasLoader, setPenaltyJanVishwasLoader] = useState<boolean>(false);
    const [searchVal, setSearchVal] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        if (globalFilter !== null && globalFilter !== undefined && globalFilter !== '' && globalFilter.length > 0) {
            getAllSearchApplications();
        }
    }, [globalFilter]);

    // Get all search applications
    const getAllSearchApplications = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(SEARCH_APPLICATION + '?search=' + searchVal);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setApplicationsList([]);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(false);
            }
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getAllSearchApplications()} />
            </>
        );
    };

    //remove serach
    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getAllSearchApplications();
    };

    // On row selection
    const onRowSelection = (value: any) => {
        navigate('/app/application/applicationViewForm/' + btoa(value.SrNo));
    };

    // Template for RegNo
    const RegNoTemplate = (rowData: any) => {
        return (
            <>
                <div className="avatar-div" onClick={() => navigate('/app/application/applicationViewForm/' + btoa(rowData.SrNo))}>
                    <div className="emp-name link-name">{rowData?.RegNo}</div>
                </div>
            </>
        );
    };

    // Template for penalty status
    const penaltyStatusTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <InputSwitch checked={rowData?.penalty_status === 1 ? true : false} onChange={(e) => onPenaltyStatusModal(e.value, rowData.SrNo)} />
                </div>
            </>
        );
    };
    const penaltyStatusJanVishwasTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn" style={{ flexDirection: 'column', minWidth: '100px' }}>
                    <InputSwitch checked={rowData?.penalty_under_jan_vishwas_status === 1 ? true : false} onChange={(e) => onPenaltyStatusJanVishwasModal(rowData.SrNo)} />{' '}
                    <div>{rowData?.penalty_under_jan_vishwas_status === 1 && <span className="ml-2">Amount : {rowData?.penalty_under_jan_vishwas_amount}</span>}</div>
                </div>
            </>
        );
    };

    // Open penalty status modal
    const onPenaltyStatusModal = (val: any, SrNo: any) => {
        let isVerified = val === true ? 1 : 0;
        setPenaltyStatus(isVerified);
        setPenaltySrNo(SrNo);
        setPenaltyModal(true);
    };
    // Close penalty status modal
    const closePenaltyStatusModal = () => {
        setPenaltySrNo(null);
        setPenaltyStatus(null);
        setPenaltyLoader(false);
        setPenaltyModal(false);
    };
    // Open penalty status jan vishwas modal
    const onPenaltyStatusJanVishwasModal = (SrNo: any) => {
        setPenaltySrNoJanVishwas(SrNo);
        setPenaltyJanVishwasModal(true);
    };
    // Close penalty status jan vishwas modal
    const closePenaltyStatusJanVishwasModal = () => {
        setPenaltySrNoJanVishwas(null);
        setPenaltyAmountJanVishwas(null);
        setPenaltyJanVishwasLoader(false);
        setPenaltyJanVishwasModal(false);
    };

    // Change penalty status
    const changePenaltyStatus = async () => {
        try {
            setPenaltyLoader(true);

            let formData: any = new FormData();
            formData.append('SrNo', penaltySrNo);
            formData.append('status', penaltyStatus);

            //apicall
            const response = await postAllData(PENALTY_UPDATE, formData);
            if (response) {
                setPenaltySrNo(null);
                setPenaltyStatus(null);
                setPenaltyLoader(false);
                setPenaltyModal(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                getAllSearchApplications();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPenaltyLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    //change penalty status jan vishwas
    const changePenaltyStatusJanVishwas = async () => {
        try {
            const { errors, isError } = PanaltyUnderJanVishwas(penaltyAmountJanVishwas);
            setErrors(errors);
            if (!isError) {
                setPenaltyJanVishwasLoader(true);
                let formData: any = new FormData();
                formData.append('SrNo', penaltySrNoJanVishwas);
                formData.append('penalty_under_jan_vishwas_amount', penaltyAmountJanVishwas);

                //apicall
                const response = await postAllData(PENALTY_UPDATE_JAN_VISHWAS, formData);
                if (response) {
                    setPenaltySrNoJanVishwas(null);
                    setPenaltyAmountJanVishwas(null);
                    setPenaltyJanVishwasLoader(false);
                    setPenaltyJanVishwasModal(false);
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: response?.message
                    });
                    getAllSearchApplications();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPenaltyJanVishwasLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <ApplicationTab mainTabLabel="Other Application" />
            <OtherApplicationTab initialTabLabel="Search" />
            <Toast ref={toast} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={applicationsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    selectionMode="single"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    // onSelectionChange={(e) => onRowSelection(e.value)}
                                >
                                    {SearchDetailsColumns.map((col, i) => {
                                        if (col.field === 'penalty_status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={penaltyStatusTemplate} />;
                                        }
                                        if (col.field === 'penalty_under_jan_vishwas_status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={penaltyStatusJanVishwasTemplate} />;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={RegNoTemplate} sortable style={{ minWidth: '7rem' }} />;
                                        } else if (col.field === 'JoingYth') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={joiningYearTemplate} style={{ minWidth: '7rem' }} />;
                                        } else if (col.field === 'Passedyth') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={passingYearTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'BOD') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationsDOBTemplate} style={{ minWidth: '7rem' }} />;
                                        } else if (col.field === 'ColName') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={collegeNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                                {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {SearchDetailsColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {/* Change Penalty Status Dialog */}
            <Dialog
                visible={penaltyModal}
                style={{ width: '450px' }}
                header="Change Penalty Status"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closePenaltyStatusModal} />
                        <Button label="Submit" icon="pi pi-check" onClick={changePenaltyStatus} loading={penaltyLoader} />
                    </>
                }
                onHide={closePenaltyStatusModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <span>Note: It will Active or Inactive Penalty.</span>
                </div>
            </Dialog>

            {/* Change Penalty Status jan viswash Dialog */}
            <Dialog
                visible={penaltyJanVishwasModal}
                style={{ width: '450px' }}
                header="Penalty under Jan Vishwas(Amendment of Provisions) Act, 2023"
                modal
                className="p-fluid"
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closePenaltyStatusJanVishwasModal} />
                        <Button label="Submit" icon="pi pi-check" onClick={changePenaltyStatusJanVishwas} loading={penaltyJanVishwasLoader} />
                    </>
                }
                onHide={closePenaltyStatusJanVishwasModal}
            >
                <div className="field">
                    <label htmlFor="amount">Penalty Amount</label>
                    <InputNumber inputId="amount" value={penaltyAmountJanVishwas} onChange={(e) => setPenaltyAmountJanVishwas(e.value)} placeholder="Enter Penalty Amount" className={errors['amount'] && 'p-invalid'} />
                    <small className="p-invalid-txt">{errors['amount']}</small>
                </div>
            </Dialog>
        </>
    );
};
